import { PRO_SUBSCRIPTION } from "@/constants";
import { comms_contact_sales_event, goto_manage_payments_event } from "@/services/posthog/events";
import { useAnalytics } from "@/services/posthog/hooks";
import { Spinner, Stack, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { goToBillingPortal } from "../../../Checkout/actions/goToBillingPortal";
import { contactSales } from "../../actions/contactSales";
import { useProducts } from "../../hooks/useProducts";
import { useSubscription } from "../../hooks/useSubscription";
import { PricingPlan } from "./PricingPlan";

interface PricingSelectorProps {
  onContactSales: () => void;
}

export const PricingSelector = (props: PricingSelectorProps) => {
  const { onContactSales } = props;
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const { data: subscription } = useSubscription();
  const { isLoading: isLoadingProducts /*data: products*/ } = useProducts();
  const analytics = useAnalytics();
  // const redirectToCheckout = useRedirectToCheckout();

  // TODO: define how we check if a user
  // has an enterprise subscription
  const hasEnterpriseSubscription = false;

  // const proSubscription = products?.find((product) => product.subscription_type === "pro");
  // const proPriceMonthly = proSubscription?.prices?.find((price) => price.interval === "monthly")?.amount;
  // const proPriceMonthlyId = proSubscription?.prices?.find((price) => price.interval === "monthly")?.stripe_price_id;
  const hasProSubscription = subscription?.type === PRO_SUBSCRIPTION;

  if (isLoading || isLoadingProducts) return <Spinner />;

  const _goToBillingPortal = async () => {
    analytics.capture(goto_manage_payments_event, { from: "pricing_selector" });
    setIsLoading(true);
    const { error } = await goToBillingPortal();
    if (error) {
      toast({
        title: "Error",
        description: "An error occurred while processing your request. Please try again later.",
        status: "error",
        position: "top",
      });
    }
    setIsLoading(false);
  };

  const _onContactRequest = async () => {
    if (!hasEnterpriseSubscription) {
      analytics.capture(comms_contact_sales_event, { from: "pricing_selector" });
      setIsLoading(true);
      contactSales();
      setIsLoading(false);
      onContactSales();
      toast({
        title: "We've received your request!",
        description: "Thank you for your interest! We will reach out to you shortly.",
        status: "success",
        duration: 10000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    analytics.capture(goto_manage_payments_event, { from: "pricing_selector" });
    setIsLoading(true);
    _goToBillingPortal();
  };

  // const onSelectProPlan = async () => {
  //   if (!hasProSubscription) {
  //     if (!proPriceMonthlyId) return;
  //     analytics.capture(goto_checkout, { from: "pricing_selector" });
  //     setIsLoading(true);
  //     const lineItems = [
  //       {
  //         price: proPriceMonthlyId,
  //         quantity: 1,
  //       },
  //     ];
  //     redirectToCheckout(lineItems, true);
  //     return;
  //   }

  //   analytics.capture(goto_manage_payments, { from: "pricing_selector" });
  //   setIsLoading(true);
  //   _goToBillingPortal();
  // };

  return (
    <Stack direction="row" justifyContent="space-between">
      <PricingPlan
        onClick={_goToBillingPortal}
        isLoading={isLoading}
        price="Free"
        isSelected={!hasProSubscription}
        isDisabled={!hasProSubscription}
        buttonText={hasProSubscription ? "Downgrade" : "Current Plan"}
        description="Best if you want to try Prompt Studio. Create promptbooks and turn them into shareable AI tools."
        header="Free"
        items={[
          "10 monthly credits included",
          "Create promptbooks",
          "Turn your promptbooks into shareable AI tools",
          "Get started quickly with templates",
          "Use preset AI behaviors",
          "Community support",
        ]}
      />
      {/* <PricingPlan
        isLoading={isLoading}
        isSelected={hasProSubscription}
        onClick={onSelectProPlan}
        price={proPriceMonthly ? `€${(proPriceMonthly / 100).toFixed(0)} / seat / month` : ""}
        buttonText={hasProSubscription ? "Cancel Subscription" : "Upgrade"}
        description="Best if you need customization and collaboration features. Work on your prompts as a team."
        header="Pro"
        items={PRO_SUBSCRIPTION_PERKS}
      /> */}
      <PricingPlan
        price="Upon request"
        isSelected={hasEnterpriseSubscription}
        onClick={_onContactRequest}
        isLoading={isLoading}
        buttonText={hasEnterpriseSubscription ? "Cancel Subscription" : "Contact Us"}
        description="Best for enterprise. Bring your own AI models, request custom features and dedicated support."
        header="Enterprise"
        items={[
          "On-Premise deployment",
          "Private Slack channel",
          "Prioritized feature requests",
          "Premium enterprise support",
        ]}
      />
    </Stack>
  );
};
